import React, { useState, useEffect } from 'react';
import { getCurrentSeasonalEffect, SEASONAL_EFFECTS } from './seasonalConfig';
import ChristmasEffect from './ChristmasEffect/ChristmasEffect';
import NewYearEffect from './NewYearEffect/NewYearEffect';
import SpringFestivalEffect from './SpringFestivalEffect/SpringFestivalEffect';
import MidAutumnEffect from './MidAutumnEffect/MidAutumnEffect';
import DoubleTenEffect from './DoubleTenEffect/DoubleTenEffect';

/**
 * 節慶特效主控制器
 * 自動根據當前日期判斷要顯示哪個特效
 */
const SeasonalEffects = () => {
  const [activeEffect, setActiveEffect] = useState(null);

  useEffect(() => {
    const checkEffect = () => {
      const effect = getCurrentSeasonalEffect();
      setActiveEffect(effect);
    };

    // 初始檢查
    checkEffect();
    
    // 每小時檢查一次（避免跨日後沒更新）
    const interval = setInterval(checkEffect, 60 * 60 * 1000);
    
    return () => clearInterval(interval);
  }, []);

  // 根據當前節慶渲染對應的特效
  const renderEffect = () => {
    switch (activeEffect) {
      case SEASONAL_EFFECTS.CHRISTMAS.id:
        return <ChristmasEffect />;
      
      case SEASONAL_EFFECTS.NEW_YEAR.id:
        return <NewYearEffect />;
      
      case SEASONAL_EFFECTS.SPRING_FESTIVAL.id:
        return <SpringFestivalEffect />;

      case SEASONAL_EFFECTS.MID_AUTUMN.id:
        return <MidAutumnEffect />;

      case SEASONAL_EFFECTS.DOUBLE_TEN.id:
        return <DoubleTenEffect />;
      
      default:
        return null;
    }
  };

  return renderEffect();
};

export default SeasonalEffects;

